import desktopIcon from '../assets/images/responsive-web-design.svg';
import frontendIcon from '../assets/images/web-interface.svg';
import backendIcon from '../assets/images/server.svg';

export default function ExpertiseSection(){
    return(
        <section id='expertise' className="section expertise">
            <div className="container">
                <h1 className="text-center mb-3">What I do</h1>
                
                <div className="row row-cols-lg-3 g-2">
                    <div className="col-md">
                        <div className="expertise-item shadow-sm">
                            <div className="expertise-icon">
                                <img src={desktopIcon} className='img img-fluid' alt='' />
                            </div>

                            <div className="expertise-title">Software Development</div>

                            <div className="expertise-description">
                                I design and create cross-platform computer systems and applications to solve real-world problems 
                                using <strong>.Net Framework </strong> and <strong>Golang</strong>.
                            </div>
                        </div>
                    </div>

                    <div className="col-md">
                        <div className="expertise-item shadow-sm">
                            <div className="expertise-icon">
                                <img src={frontendIcon} className='img img-fluid' alt='' />
                            </div>

                            <div className="expertise-title">
                            Frontend Web Development
                            </div>

                            <div className="expertise-description">
                            I design build responsive web applications using <strong>Blazor</strong>, <strong>React</strong> and <strong>other modern UI framework tools</strong>. 
                                I can also handle the integration of web applications with APIs.
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6">
                        <div className="expertise-item shadow-sm">
                            <div className="expertise-icon">
                                <img src={backendIcon} className='img img-fluid' alt='' />
                            </div>

                            <div className="expertise-title">
                            Backend Web Development
                            </div>

                            <div className="expertise-description">
                            I have great skills in building,testing,maintaining and deploying robust and secure 
                                web servers using <strong>Laravel</strong>, <strong>ASP.Net Core</strong>, <strong>Golang </strong> 
                                as well as caching stystems such as <strong>Redis</strong> and several database technologies.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}